<!-- eslint-disable max-len -->
<template>
  <div>
    <v-server-table
      v-if="show_table"
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="clickDetail">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="createData">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
        </b-form>
      </div>
      <div
        slot="active"
        slot-scope="props">
        {{ props.row.active ? 'Aktif' : 'Tidak Aktif' }}
      </div>
    </v-server-table>
    <jLoadingTable v-if="show_table && !load_first"/>

    <b-modal
      ref="modalPoin"
      class="mod-form modal-tahun-ajaran"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <div class="title-bold ql-align-center">{{ data_master.id ? 'Rubah' : 'Tambah' }} Poin</div>

      <!-- <b-form-group :class="{'error-input' : $v.data_master.tahunajaran.$error}">
        <label> Tahun Ajaran </label>
        <j-single-select
          v-model="$v.data_master.tahunajaran.$model"
          :options="list_tahun_ajaran"
          :placeholder="'Select Tahun Ajaran'"
          value-format="object"
          label="tahunajaran"/>
      </b-form-group> -->

      <b-form-group :class="{'error-input' : $v.data_master.point_prestasi.$error}">
        <label> Poin Prestasi </label>
        <j-input
          v-model="$v.data_master.point_prestasi.$model"
          :disabled="readOnly"
          placeholder="Poin Prestasi"
          type="number"/>
      </b-form-group>

      <b-form-group :class="{'error-input' : $v.data_master.point_pelanggaran.$error}">
        <label> Poin Pelanggaran (-) </label>
        <j-input
          v-model="$v.data_master.point_pelanggaran.$model"
          :disabled="readOnly"
          placeholder="Poin Pelanggaran (-)"
          type="number"/>
      </b-form-group>

      <b-form-group :class="{'error-input' : $v.data_master.active.$error}">
        <label> STATUS </label>
        <j-single-select
          v-model="$v.data_master.active.$model"
          :options="list_status"
          :disabled="readOnly"
          placeholder="Pilih Status"
          value-format="object"
          label="name"/>
      </b-form-group>

      <b-row>
        <b-col md="4">
          <b-button
            v-if="data_master.id && !readOnly"
            class="btn red"
            @click="deleteData">
            Delete
          </b-button>
        </b-col>
        <b-col md="8">
          <div class="float-to-right">
            <b-button
              class="btn gray"
              @click="closeData">
              Cancel
            </b-button>
            <b-button
              v-if="!readOnly"
              class="btn blue m__l--5"
              @click="saveData">
              {{ data_master.id ? 'Update' : 'Save' }}
            </b-button>
          </div>
        </b-col>
      </b-row>

    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKesiswaan from '@/services/jApiKesiswaan';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  components: {
    jLoadingTable,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      tahunajaran: '',
      dataTahunAjaran: null,
      data_master: {
        tahunajaran: null,
        point_prestasi: 0,
        point_pelanggaran: 0,
        active: null,
      },
      list_tahun_ajaran: [],
      list_status: [
        {
          id: true,
          name: 'Aktif',
        },
        {
          id: false,
          name: 'Tidak Aktif',
        },
      ],
      show_table: false,
      load_first: false,
      data_table: [],
      columns: ['id', 'tahunajaran', 'point_prestasi', 'point_pelanggaran', 'active'],
      options: {
        headings: {
          id: 'ID',
          tahunajaran: 'TAHUN AJARAN',
          point_prestasi: 'POINT PRESTASI',
          point_pelanggaran: 'POIN PELANGGARAN',
          active: 'STATUS',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: [],
        perPage: 1000,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            pagination: {
              tahunajaran: data.tahunajaran,
            },
          };
        },
        requestFunction(data) {
          const getList = jApiKesiswaan.listPoin(data.pagination);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },
    };
  },
  computed: {
  },
  watch: {
    filter_data(val) {
      if (val === '') {
        this.$refs.tableServer.setFilter('');
      }
    },
  },
  created() {
    this.listTahunAjaran();
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKesiswaan', ['createPoin', 'updatePoin', 'deletePoin', 'getListTahunAjaran']),

    listTahunAjaran() {
      const paramTahunAjaran = {
        pagination: {
          query: '',
          query_type: '',
        },
      };
      this.getListTahunAjaran(paramTahunAjaran).then((res) => {
        this.list_tahun_ajaran = res.data.data;
        this.dataTahunAjaran = res.data.data.find(f => f.id === this.$route.params.id);
        this.show_table = true;
      });
    },

    loading(val) {
      const a = val;
      a.pagination.tahunajaran = this.dataTahunAjaran.tahunajaran;
      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;
      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    refreshTable() {
      this.$refs.tableServer.getData();
    },

    filter(val) {
      this.$refs.tableServer.setFilter(val);
    },

    createData() {
      this.$refs.modalPoin.show();
    },

    closeData() {
      this.$refs.modalPoin.hide();
      this.data_master = {
        tahunajaran: null,
        point_prestasi: 0,
        point_pelanggaran: 0,
        active: null,
      };
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        const params = this.data_master;
        params.tahunajaran = this.dataTahunAjaran.tahunajaran;
        params.active = this.data_master.active.id;
        const action = this.data_master.id ? 'updatePoin' : 'createPoin';
        this[action](params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeData();
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_master.id,
          };
          this.deletePoin(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeData();
              }, 1500);
            }
          });
        }
      });
    },

    clickDetail({ row }) {
      this.$refs.modalPoin.show();
      this.data_master = {
        id: row.id,
        tahunajaran: null,
        point_pelanggaran: row.point_pelanggaran,
        point_prestasi: row.point_prestasi,
        active: { id: row.active },
      };
    },
  },
  validations() {
    return {
      tahunajaran: {},
      data_master: {
        tahunajaran: { },
        point_pelanggaran: { required },
        point_prestasi: { required },
        active: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/poin/jPoin.vue